import axios from 'axios';
const rcoBackendPrefix = '/portal/Bankszamla/api';
export default {
	getWebsalesId() {
		return axios.get(rcoBackendPrefix + '/websales/cookie');
	},
	sendGoodsLoanData(token, environment) {
		return axios.post(rcoBackendPrefix + '/websales/aruhitel', { token, enviroment: environment });
	},
	sendPackageData(packageData) {
		return axios.post(rcoBackendPrefix + '/websales/uj-szamlacsomag', packageData);
	}
};
